import { Navigate } from 'react-router-dom';
import { DEFAULT_PATH } from '@/routes/paths';
import TokenService from '@/services/TokenService/TokenService';

type Props = {
  children: React.ReactNode;
};

export const UnAuthProtectedPage = ({ children }: Props) => {
  const token = TokenService.getTokenData();

  const isSignedIn = !!token;

  return isSignedIn ? <Navigate to={DEFAULT_PATH} /> : children;
};
